interface FeatureFlagsMap {
  [index: string]: string | undefined;
}

/**
 * Class to keep track of which features/treatments the user is in for analytics purposes
 */
class FeatureFlags {
  featureFlags: FeatureFlagsMap = {};
  constructor() {
    this.featureFlags = {};
  }

  getAllCachedTreatments = () => this.featureFlags;

  setTreatment = (featureName: string, treatment: string) => {
    this.featureFlags[featureName] = treatment;
  };
}

export const featureFlags = new FeatureFlags();
